import { render } from "./addPrescription.vue?vue&type=template&id=4f261eed&scoped=true"
import script from "./addPrescription.vue?vue&type=script&lang=js"
export * from "./addPrescription.vue?vue&type=script&lang=js"

import "./addPrescription.vue?vue&type=style&index=0&id=4f261eed&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f261eed"]])

export default __exports__